import { getAdsInfo } from '@/apis/ads-info';
import { ADS_INFO } from '../mutation-types';

export const state = {
  ads: {
    estateHour: 0,
    estateDay: 0,
    prefectures: [],
    priceMax: [],
    estateType: [],
    yearBuild: []
  },
};

export const getters = {
  adsInfo: state => {
    state.ads.estateDay = state.ads.estate_day;
    state.ads.estateHour = state.ads.estate_hour;
    state.ads.prefectures = state.ads.prefectures?.map((prefecture) => ({
      name: prefecture.code_name,
      id: prefecture.code_id
    }));

    state.ads.priceMax = state.ads.price_max?.map((price) => ({
      name: price.code_name,
      id: price.code_id,
      biko1: price.biko1
    }));

    state.ads.estateType = state.ads.estate_type?.map((estate) => ({
      name: estate.code_name,
      id: estate.code_id
    }));

    state.ads.yearBuild = state.ads.year_build?.map((year) => ({
      name: year.code_name,
      id: year.code_id,
      biko1: year.biko1
    }));

    return state.ads;
  }
};

export const mutations = {
  [ADS_INFO.GET_ADS_INFO](state, data) {
    if (!data.error) {
      state.ads = data;
    }
  },
};

export const actions = {
  async getAdsInfo({ commit }) {
    const res = await getAdsInfo();
    commit(ADS_INFO.GET_ADS_INFO, res);
  },
};
